module.exports = __webpack_public_path__ + "img/No_Available_Data.20d71da8.svg";